export default {"src":"/_next/static/media/brokenWindow_40.b6545fd5.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};